import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-auto"
}
const _hoisted_2 = { class: "card py-2 px-2" }
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 4 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 5 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[13] || (_cache[13] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Scheduling Dates"),
      _createElementVNode("p", null, [
        _createElementVNode("small", null, "Set date ranges that are open for scheduling a visit for each partner.")
      ])
    ], -1)),
    (!_ctx.loading && !_ctx.has_error && _ctx.partners)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "thead-dark" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "header-row py-2 px-2" }, "Partner Name"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Partner Slug"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Date Range"),
                  _createElementVNode("th", { class: "header-row py-2" }, "Disabled Date Range")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (partner) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: partner.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(partner.short_name), 1),
                    _createElementVNode("td", null, _toDisplayString(partner.slug), 1),
                    (partner.dates == null && !partner.set_dates)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Not Set", -1)),
                          _createElementVNode("span", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary ms-4",
                              onClick: ($event: any) => (_ctx.setDates(partner.id))
                            }, "Set Dates", 8, _hoisted_5)
                          ])
                        ]))
                      : (partner.dates != null && !partner.set_dates)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.moment(partner.dates.start_date).format('MM/DD/YY')) + " - " + _toDisplayString(_ctx.moment(partner.dates.end_date).format('MM/DD/YY')), 1),
                            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", null, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: ($event: any) => (_ctx.setDates(partner.id))
                              }, "Modify Dates", 8, _hoisted_7)
                            ]),
                            _createElementVNode("span", null, [
                              _createElementVNode("button", {
                                class: "btn btn-primary ms-4",
                                onClick: ($event: any) => (_ctx.clearDates(partner.id))
                              }, "Clear Dates", 8, _hoisted_8)
                            ])
                          ]))
                        : (partner.set_dates)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_9, [
                              _createElementVNode("span", null, [
                                _createVNode(_component_datepicker, {
                                  class: "float-start date-margin",
                                  "lower-limit": new Date(),
                                  placeholder: "Select Start Date...",
                                  modelValue: _ctx.start_date,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.start_date) = $event))
                                }, null, 8, ["lower-limit", "modelValue"]),
                                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "float-start mx-2" }, " - ", -1)),
                                _createVNode(_component_datepicker, {
                                  class: "float-start date-margin",
                                  "lower-limit": new Date(),
                                  placeholder: "Select End Date...",
                                  modelValue: _ctx.end_date,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.end_date) = $event))
                                }, null, 8, ["lower-limit", "modelValue"])
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary ms-4",
                                  onClick: ($event: any) => (_ctx.saveDates(partner.id))
                                }, "Save", 8, _hoisted_10)
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary ms-4",
                                  onClick: ($event: any) => (_ctx.hideDates(partner.id))
                                }, "Cancel", 8, _hoisted_11)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                    (partner.disabled_dates == null && !partner.set_disabled_dates)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Not Set", -1)),
                          _createElementVNode("span", null, [
                            _createElementVNode("button", {
                              class: "btn btn-primary ms-4",
                              onClick: ($event: any) => (_ctx.setDisabledDates(partner.id))
                            }, "Set Disabled Dates", 8, _hoisted_13)
                          ])
                        ]))
                      : (partner.disabled_dates != null && !partner.set_disabled_dates)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.moment(partner.disabled_dates.start_date).format('MM/DD/YY')) + " - " + _toDisplayString(_ctx.moment(partner.disabled_dates.end_date).format('MM/DD/YY')), 1),
                            _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", null, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: ($event: any) => (_ctx.setDisabledDates(partner.id))
                              }, "Modify Disabled Dates", 8, _hoisted_15)
                            ]),
                            _createElementVNode("span", null, [
                              _createElementVNode("button", {
                                class: "btn btn-primary ms-4",
                                onClick: ($event: any) => (_ctx.clearDisabledDates(partner.id))
                              }, "Clear Disabled Dates", 8, _hoisted_16)
                            ])
                          ]))
                        : (partner.set_disabled_dates)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                              _createElementVNode("span", null, [
                                _createVNode(_component_datepicker, {
                                  class: "float-start date-margin",
                                  "lower-limit": new Date(),
                                  placeholder: "Select Start Date...",
                                  modelValue: _ctx.start_disabled_date,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.start_disabled_date) = $event))
                                }, null, 8, ["lower-limit", "modelValue"]),
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "float-start mx-2" }, " - ", -1)),
                                _createVNode(_component_datepicker, {
                                  class: "float-start date-margin",
                                  "lower-limit": new Date(),
                                  placeholder: "Select End Date...",
                                  modelValue: _ctx.end_disabled_date,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.end_disabled_date) = $event))
                                }, null, 8, ["lower-limit", "modelValue"])
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary ms-4",
                                  onClick: ($event: any) => (_ctx.saveDisabledDates(partner.id))
                                }, "Save", 8, _hoisted_18)
                              ]),
                              _createElementVNode("span", null, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary ms-4",
                                  onClick: ($event: any) => (_ctx.hideDisabledDates(partner.id))
                                }, "Cancel", 8, _hoisted_19)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.has_error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Error", -1)),
            _createElementVNode("p", { innerHTML: _ctx.error_msg }, null, 8, _hoisted_21)
          ]))
        : (!_ctx.loading && !_ctx.has_error && !_ctx.partners)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[12] || (_cache[12] = [
              _createElementVNode("p", null, "No partners in system", -1)
            ])))
          : _createCommentVNode("", true),
    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}